var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"clueScan"}},[_c('van-empty',{attrs:{"description":"该功能已停用"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }